import { computeCardPoints, getCardKpiFields } from './kpi'

export const MAX_TIMER_SESSION_MINUTES = 180
export const MAX_TIMER_SESSION_SECONDS = MAX_TIMER_SESSION_MINUTES * 60

export function clampTimerSessionSeconds(seconds, maxSeconds = MAX_TIMER_SESSION_SECONDS) {
    const value = Math.max(0, Number(seconds) || 0)
    if (!Number.isFinite(value)) return 0
    return Math.min(value, maxSeconds)
}

export function normalizeCompletionPayload(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        return { by_user: {} }
    }

    return {
        ...payload,
        by_user: payload.by_user && typeof payload.by_user === 'object' && !Array.isArray(payload.by_user)
            ? payload.by_user
            : {},
    }
}

export function buildUserCompletionPayload({ payload, userId, fields = [], values = {}, submittedAt = new Date().toISOString() }) {
    if (!userId) return { payload: normalizeCompletionPayload(payload), submittedAt }

    const normalized = normalizeCompletionPayload(payload)
    const trimmedValues = fields.reduce((acc, field) => {
        acc[field.key] = String(values?.[field.key] ?? '').trim()
        return acc
    }, {})

    return {
        submittedAt,
        payload: {
            ...normalized,
            by_user: {
                ...(normalized.by_user || {}),
                [userId]: {
                    submitted_at: submittedAt,
                    values: trimmedValues,
                },
            },
        },
    }
}

export function getUserCompletionValues(payload, userId) {
    if (!userId) return {}
    return normalizeCompletionPayload(payload).by_user?.[userId]?.values || {}
}

export function elapsedSecondsSince(startedAt, nowMs = Date.now()) {
    if (!startedAt) return 0
    const startedMs = new Date(startedAt).getTime()
    if (!Number.isFinite(startedMs)) return 0
    return Math.max(0, Math.round((nowMs - startedMs) / 1000))
}

export function timerLogMinutes(elapsedSeconds, { minSeconds = 0, minMinutes = 1 } = {}) {
    const seconds = clampTimerSessionSeconds(elapsedSeconds)
    if (seconds < minSeconds) return 0
    return Math.max(minMinutes, Math.round(seconds / 60))
}

export function buildStopTimerPatch(card, { nowMs = Date.now(), baseTrackedSeconds } = {}) {
    const elapsedSec = clampTimerSessionSeconds(elapsedSecondsSince(card?.timer_started_at, nowMs))
    const base = Number.isFinite(Number(baseTrackedSeconds))
        ? Number(baseTrackedSeconds)
        : (Number(card?.tracked_seconds) || 0)

    return {
        elapsedSec,
        patch: {
            tracked_seconds: base + elapsedSec,
            timer_started_at: null,
        },
    }
}

export function computeCompletionAward(card, values = {}, { defaultFlatPoints = 5 } = {}) {
    const fields = getCardKpiFields(card)
    if (fields.length > 0) {
        let points = computeCardPoints(card, values)
        if (!(points > 0)) {
            const flat = Number(card?.point_value)
            points = Number.isFinite(flat) && flat > 0 ? flat : defaultFlatPoints
        }
        return {
            points: Math.max(0, Math.round(points)),
            reason: 'kpi_submitted',
            kpiValues: values || {},
        }
    }

    const flat = Number(card?.point_value)
    const points = Number.isFinite(flat) && flat > 0 ? flat : defaultFlatPoints
    return {
        points: Math.max(0, Math.round(points)),
        reason: 'Card completat',
        kpiValues: null,
    }
}
